const behavioralHistoryJSON = {
  section: "PS",
  topic: "Behavioral Health History",
  checked: "true",
  color: "secondary",
  description: "",
  body: [
    {
      id: "BH.1",
      shortname: "ps-new0",
      name: "How many times have you been treated for any psychological or mental health problem ",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "subtopic",
      act: "PS-NEW0-SUBTOPIC",
      depending: "",
      exception: ""
    },
    {
      id: "BH.1.1",
      shortname: "ps1",
      name: "",
      prevalue: "How many times?",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "number",
      select_options: [
        "",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
      ],
      act: "PS1",
      mandatory: "true",
      depending: "",
      exception: "",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_HOSPITAL",
      subtopic_name: "Hospital/Residential/Inpatient Setting"
    },
    {
      id: "BH.1.1.1",
      shortname: "ps1-new2",
      name: "",
      prevalue: "If once or more, when was the most recent hospitalization and for what reason?",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS1-NEW2",
      depending: "PS1",
      exception: "0",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_HOSPITAL",
      subtopic_name: "Hospital/Residential/Inpatient Setting"
    },
    {
      id: "BH.1.2",
      shortname: "ps2",
      name: "",
      prevalue: "How many times?",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "number",
      select_options: [
        "",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
      ],
      act: "PS2",
      mandatory: "true",
      depending: "",
      exception: "",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting"
    },
    {
      id: "BH.1.2.1",
      shortname: "ps1-new4",
      name: "",
      prevalue: "",
      value: "?",
      label:"If you are currently receiving treatment, please list all your current providers and indicate what type of provider",
      disabled: "true",
      type: "label",
      act: "PS1-NEW4",
      depending: "PS2",
      exception: "0",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting"
    },
    {
      id: "BH.1.2.2",
      shortname: "ps2-2-vir",
      name: "",
      prevalue: "Provider Name #1:",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS2-2-VIR",
      depending: "PS2",
      exception: "0",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      extend: "true",
      link: "PS2-3-VIR"
    },
    {
      id: "BH.1.2.3",
      shortname: "ps2-3-vir",
      name: "",
      prevalue: "Provider phone number #1:",
      value: "",
      disabled: "true",
      type: "phone",
      act: "PS2-3-VIR",
      depending: "PS2",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      exception: "0",
      extend: "true",
      link: "PSPS2-3ADD-VIR"
    },
    {
      id: "BH.1.2.4",
      shortname: "ps2-3add-vir",
      name: "",
      prevalue: "",
      value: "",
      disabled: "true",
      type: "radio",
      radio_options: [
        "Medication",
        "Therapist/Counselor"
      ],
      act: "PS2-3ADD-VIR",
      mandatory: "true",
      depending: "PS2",
      exception: "0",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      extend: "true",
      link: "PS2-4ADD-VIR"
    },
    {
      id: "BH.1.2.5",
      shortname: "ps2-4add-vir",
      name: "",
      prevalue: "Add second provider?",
      value: "",
      disabled: "true",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS2-4ADD-VIR",
      depending: "PS2",
      exception: "0",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      link: "PS2-4-VIR",
      extend: "true"
    },
    {
      id: "BH.1.2.5.1",
      shortname: "ps2-4-vir",
      name: "",
      prevalue: "Provider Name #2:",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS2-4-VIR",
      depending: "PS2-4ADD-VIR",
      exception: "Yes",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      extend: "true",
      link: "PS2-5-VIR"
    },
    {
      id: "BH.1.2.5.2",
      shortname: "ps2-5-vir",
      name: "",
      prevalue: "Provider phone number #2:",
      value: "",
      disabled: "true",
      type: "phone",
      act: "PS2-5-VIR",
      depending: "PS2-4ADD-VIR",
      exception: "Yes",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      extend: "true",
      link: "PS2-5ADD-VIR"
    },
    {
      id: "BH.1.2.5.3",
      shortname: "ps2-5add-vir",
      name: "",
      prevalue: "",
      value: "",
      disabled: "true",
      type: "radio",
      radio_options: [
        "Medication",
        "Therapist/Counselor"
      ],
      act: "PS2-5ADD-VIR",
      depending: "PS2-4ADD-VIR",
      exception: "Yes",
      subtopic_container_act: "PS-NEW0-SUBTOPIC",
      suptopic_code: "PS-NEW0_OUTPATIENT",
      subtopic_name: "Outpatient/Private Patient Setting",
      extend: "true"
    },
    {
      id: "BH.2",
      shortname: "ps3",
      name: "Do you receive any disability payments for a mental health problem?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS3",
      mandatory: "true",
      depending: "",
      exception: "",
      link: "PS1-NEW6"
    },
    {
      id: "BH.2.1",
      shortname: "ps1-new6",
      name: "",
      prevalue: "If yes, what is the reason for the disability and what is the amount you receive?",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS1-NEW6",
      depending: "PS3",
      exception: "Yes",
      extend: "true"
    },
    {
      id: "BH.3",
      shortname: "fr23-subtopic",
      name: "Have you experienced any of the following symptoms? All of the items below have been defaulted to NO. If your answer is YES, please change NO to YES. ",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "subtopic",
      act: "FR23-SUBTOPIC",
      depending: "",
      exception: ""
    },
    {
      id: "BH.3.1",
      shortname: "ps5",
      name: "serious anxiety",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS5",
      depending: "",
      exception: "",
      link: "PS5-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23-ANXIETY",
      subtopic_name: "Serious Anxiety"
    },
    {
      id: "BH.3.1.1",
      extend: "true",
      shortname: "ps5-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS5-YES",
      depending: "PS5",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23-ANXIETY",
      subtopic_name: "Serious Anxiety",
      link: "PS5-1"
    },
    {
      id: "BH.3.2",
      extend: "true",
      shortname: "ps5-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS5-1",
      depending: "",
      exception: "",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23-ANXIETY",
      subtopic_name: "Serious Anxiety",
      link: "PS5-1-YES"
    },
    {
      id: "BH.3.2.1",
      extend: "true",
      shortname: "ps5-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS5-1-YES",
      depending: "PS5-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23-ANXIETY",
      subtopic_name: "Serious Anxiety"
    },
    {
      id: "BH.3.3",
      shortname: "ps4",
      name: "serious depression",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS4",
      depending: "",
      exception: "",
      link: "PS4-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_DEPRESSION",
      subtopic_name: "Serious Depression"
    },
    {
      id: "BH.3.3.1",
      extend: "true",
      shortname: "ps4-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS4-YES",
      depending: "PS4",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_DEPRESSION",
      subtopic_name: "Serious Depression",
      link: "PS4-1"
    },
    {
      id: "BH.3.4",
      extend: "true",
      shortname: "ps4-1",
      name: "",
      prevalue: "In your lifetime",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS4-1",
      depending: "",
      exception: "",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_DEPRESSION",
      subtopic_name: "Serious Depression",
      link: "PS4-1-YES"
    },
    {
      id: "BH.3.4.1",
      extend: "true",
      shortname: "ps4-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS4-1-YES",
      depending: "PS4-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_DEPRESSION",
      subtopic_name: "Serious Depression"
    },
    {
      id: "BH.3.5",
      shortname: "ps11",
      name: "attempted suicide",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS11",
      depending: "",
      exception: "",
      link: "PS11-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDE",
      subtopic_name: "Attempted Suicide"
    },
    {
      id: "BH.3.5.1",
      extend: "true",
      shortname: "ps11-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS11-YES",
      depending: "PS11",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDE",
      subtopic_name: "Attempted Suicide",
      link: "PS11-1"
    },
    {
      id: "BH.3.6",
      extend: "true",
      shortname: "ps11-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS11-1",
      depending: "",
      exception: "",
      link: "PS11-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDE",
      subtopic_name: "Attempted Suicide"
    },
    {
      id: "BH.3.6.1",
      extend: "true",
      shortname: "ps11-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS11-1-YES",
      depending: "PS11-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDE",
      subtopic_name: "Attempted Suicide"
    },
    {
      id: "BH.3.7",
      shortname: "ps10",
      name: "serious thoughts of suicide",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS10",
      depending: "",
      exception: "",
      link: "PS10-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDETHOGUHTS",
      subtopic_name: "Serious thoughts of suicide"
    },
    {
      id: "BH.3.7.1",
      extend: "true",
      shortname: "ps10-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS10-YES",
      depending: "PS10",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDETHOGUHTS",
      subtopic_name: "Serious thoughts of suicide",
      link: "PS10-1"
    },
    {
      id: "BH.3.8",
      extend: "true",
      shortname: "ps10-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS10-1",
      depending: "",
      exception: "",
      link: "PS10-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDETHOGUHTS",
      subtopic_name: "Serious thoughts of suicide"
    },
    {
      id: "BH.3.8.1",
      extend: "true",
      shortname: "ps10-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS10-1-YES",
      depending: "PS10-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_SUICIDETHOGUHTS",
      subtopic_name: "Serious thoughts of suicide"
    },
    {
      id: "BH.3.9",
      shortname: "ps6",
      name: "eating disorder such as anorexia, bulimia or over eating",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS6",
      depending: "",
      exception: "",
      link: "PS6-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ED",
      subtopic_name: "Eating disorder such as anorexia, bulimia or over eating"
    },
    {
      id: "BH.3.9.1",
      extend: "true",
      shortname: "ps6-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS6-YES",
      depending: "PS6",
      exception: "Yes",
      link: "PS6-1",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ED",
      subtopic_name: "Eating disorder such as anorexia, bulimia or over eating"
    },
    {
      id: "BH.3.10",
      extend: "true",
      shortname: "ps6-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS6-1",
      depending: "",
      exception: "",
      link: "PS6-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ED",
      subtopic_name: "Eating disorder such as anorexia, bulimia or over eating"
    },
    {
      id: "BH.3.10.1",
      extend: "true",
      shortname: "ps6-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS6-1-YES",
      depending: "PS6-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ED",
      subtopic_name: "Eating disorder such as anorexia, bulimia or over eating"
    },
    {
      id: "BH.3.11",
      shortname: "ps9",
      name: "cut on yourself or did other self-injurious behaviors",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS9",
      depending: "",
      exception: "",
      link: "PS9-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_CUT",
      subtopic_name: "Cut on yourself or did other self-injurious behaviors"
    },
    {
      id: "BH.3.11.1",
      extend: "true",
      shortname: "ps9-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS9-YES",
      depending: "PS9",
      exception: "Yes",
      link: "PS9-1",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_CUT",
      subtopic_name: "Cut on yourself or did other self-injurious behaviors"
    },
    {
      id: "BH.3.12",
      extend: "true",
      shortname: "ps9-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS9-1",
      depending: "",
      exception: "",
      link: "PS9-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_CUT",
      subtopic_name: "Cut on yourself or did other self-injurious behaviors"
    },
    {
      id: "BH.3.12.1",
      extend: "true",
      shortname: "ps9-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS9-1-YES",
      depending: "PS9-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_CUT",
      subtopic_name: "Cut on yourself or did other self-injurious behaviors"
    },
    {
      id: "BH.3.13",
      shortname: "ps8",
      name: "serious loss of temper, rage, or violence",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS8",
      depending: "",
      exception: "",
      link: "PS8-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_TEMPER",
      subtopic_name: "serious loss of temper, rage, or violence"
    },
    {
      id: "BH.3.13.1",
      extend: "true",
      shortname: "ps8-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS8-YES",
      depending: "PS8",
      exception: "Yes",
      link: "PS8-1",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_TEMPER",
      subtopic_name: "serious loss of temper, rage, or violence"
    },
    {
      id: "BH.3.14",
      extend: "true",
      shortname: "ps8-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS8-1",
      depending: "",
      exception: "",
      link: "PS8-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_TEMPER",
      subtopic_name: "serious loss of temper, rage, or violence"
    },
    {
      id: "BH.3.14.1",
      extend: "true",
      shortname: "ps8-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS8-1-YES",
      depending: "PS8-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_TEMPER",
      subtopic_name: "serious loss of temper, rage, or violence"
    },
    {
      id: "BH.3.15",
      shortname: "ps12",
      name: "trouble concentrating, understanding or remembering things (ADHD)",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS12",
      depending: "",
      exception: "",
      link: "PS12-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ADD",
      subtopic_name: "Trouble concentrating, understanding or remembering things (ADHD)"
    },
    {
      id: "BH.3.15.1",
      extend: "true",
      shortname: "ps12-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS12-YES",
      depending: "PS12",
      exception: "Yes",
      link: "PS12-1",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ADD",
      subtopic_name: "Trouble concentrating, understanding or remembering things (ADHD)"
    },
    {
      id: "BH.3.16",
      extend: "true",
      shortname: "ps12-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS12-1",
      depending: "",
      exception: "",
      link: "PS12-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ADD",
      subtopic_name: "Trouble concentrating, understanding or remembering things (ADHD)"
    },
    {
      id: "BH.3.16.1",
      extend: "true",
      shortname: "ps12-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS12-1-YES",
      depending: "PS12-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_ADD",
      subtopic_name: "Trouble concentrating, understanding or remembering things (ADHD)"
    },
    {
      id: "BH.3.17",
      shortname: "ps7",
      name: "auditory or visual hallucinations",
      prevalue: "In the past 30 days?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS7",
      depending: "",
      exception: "",
      link: "PS7-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_HALL",
      subtopic_name: "Auditory or visual hallucinations"
    },
    {
      id: "BH.3.17.1",
      extend: "true",
      shortname: "ps7-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS7-YES",
      depending: "PS7",
      exception: "Yes",
      link: "PS7-1",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_HALL",
      subtopic_name: "Auditory or visual hallucinations"
    },
    {
      id: "BH.3.18",
      extend: "true",
      shortname: "ps7-1",
      name: "",
      prevalue: "In your lifetime?",
      value: "No",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS7-1",
      depending: "",
      exception: "",
      link: "PS7-1-YES",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_HALL",
      subtopic_name: "Auditory or visual hallucinations"
    },
    {
      id: "BH.3.18.1",
      extend: "true",
      shortname: "ps7-1-yes",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS7-1-YES",
      depending: "PS7-1",
      exception: "Yes",
      subtopic_container_act: "FR23-SUBTOPIC",
      suptopic_code: "FR23_HALL",
      subtopic_name: "Auditory or visual hallucinations"
    },
    {
      id: "BH.4",
      shortname: "pss12",
      name: "How many days in the past 30 have you experienced these psychological or emotional problems?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "number",
      select_options: [
        "",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30"
      ],
      act: "PSS12",
      mandatory: "true",
      depending: "",
      exception: ""
    },
    {
      id: "BH.5",
      shortname: "ps15",
      name: "Have you EVER been diagnosed with any mental health or psychological condition(s)? ",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS15",
      mandatory: "true",
      depending: "",
      exception: "",
      link: "PS15-17"
    },
    {
      id: "BH.5.1",
      extend: "true",
      shortname: "ps15-17",
      name: "",
      prevalue: "If yes, what was the diagnosis? List current diagnoses and history of previous diagnoses.",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS15-17",
      depending: "PS15",
      exception: "Yes"
    },
    {
      id: "BH.6",
      shortname: "ps13",
      name: "Have you EVER been prescribed any medication for mental health or psychological condition(s)?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS13",
      mandatory: "true",
      depending: "",
      exception: "",
      link: "PSS30-VIR"
    },
    {
      id: "BH.6.1",
      extend: "true",
      shortname: "pss30-vir",
      name: "Manage Medications",
      header: [
        "Name:",
        "Dose:",
        "Frequency:",
        "Prescriber:",
        "Reason:"
      ],
      prevalue: "",
      value2: "",
      type2: "text",
      value3: "",
      type3: "text",
      value4: "",
      type4: "text",
      value5: "",
      type5: "text",
      value6: "",
      type6: "text",
      disabled: "true",
      type: "mtable",
      act: "PSS30-VIR",
      idTable: "PSS30",
      depending: "PS13",
      exception: "Yes",
      row: 1
    },
    {
      id: "BH.7",
      shortname: "ps26-vir",
      name: "Do you have any history of abuse, neglect, sexual or domestic violence, or trauma, including psychological trauma?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "Yes",
        "No"
      ],
      act: "PS26-VIR",
      mandatory: "true",
      depending: "",
      exception: "",
      link: "PS26-1-VIR"
    },
    {
      id: "BH.7.1",
      shortname: "ps26-1-vir",
      name: "",
      prevalue: "If yes, please explain",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS26-1-VIR",
      depending: "PS26-VIR",
      exception: "Yes",
      extend: "true"
    },
    {
      id: "BH.8",
      shortname: "ps16",
      name: "How worried or bothered have you been about any mental health or psychological condition in the past 30 days?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "string",
      select_options: [
        "",
        "not at all",
        "slightly",
        "moderately",
        "considerably",
        "extremely"
      ],
      act: "PS16",
      mandatory: "true",
      depending: "",
      exception: "",
      link: "PS16-1"
    },
    {
      id: "BH.8.1",
      shortname: "ps16-1",
      name: "",
      prevalue: "Please explain the reason you are worried or bothered?",
      value: "",
      disabled: "true",
      type: "text",
      act: "PS16-1",
      depending: "PS16",
      exception: "not at all",
      extend: "true"
    },
    {
      id: "BH.9",
      shortname: "ps17",
      name: "How important is it for you to receive additional counseling or treatment for any mental health or psychological concerns?",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "string",
      select_options: [
        "",
        "not at all",
        "slightly",
        "moderately",
        "considerably",
        "extremely"
      ],
      act: "PS17",
      depending: "",
      exception: ""
    },
    {
      id: "BH.10",
      shortname: "ps26-b-vir",
      name: "",
      prevalue: "Counselor: Describe previous Interventions by providers and timeframes and response to treatment: include the types of interventions that have been provided to the individual. Include the date(s) of the mental health interventions and the name of the mental health provider(s):",
      value: "",
      disabled: "false",
      type: "editor",
      act: "PS26-B-VIR",
      depending: "",
      exception: ""
    },
    {
      id: "BH.11",
      shortname: "ps18c",
      access: "private",
      name: "Additional comments:",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "editor",
      act: "PS18C",
      depending: "",
      exception: ""
    },
    {
      id: "BH.12",
      shortname: "ps18d",
      access: "private",
      name: "INTERVIEWER SEVERITY RATING",
      prevalue: "How would you rate the patient’s need for psychiatric/ psychological treatment?",
      value: "",
      disabled: "false",
      type: "select",
      ruletype: "string",
      select_options: [
        "",
        "not at all",
        "slightly",
        "moderately",
        "considerably",
        "extremely"
      ],
      act: "PS18D",
      mandatory: "true",
      depending: "",
      exception: ""
    },
    {
      id: "BH.13",
      shortname: "pss22-pss23-subtopic",
      access: "private",
      name: "CONFIDENCE RATINGS. Is the above information significantly distorted by:",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "subtopic",
      act: "PSS22-PSS23-ACT",
      depending: "",
      exception: ""
    },
    {
      id: "BH.13.1",
      shortname: "pss22",
      access: "private",
      name: "",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "No",
        "Yes"
      ],
      act: "PSS22",
      mandatory: "true",
      depending: "",
      exception: "",
      link:"PSS22-1",
      subtopic_container_act: "PSS22-PSS23-ACT",
      suptopic_code: "PSS22-CODE",
      subtopic_name: "Client's misrepresentation?"
    },
    {
      id: "BH.13.1.1",
      shortname: "pss22-1",
      name: "",
      prevalue: "If yes, please explain:",
      value: "",
      disabled: "true",
      type: "text",
      act: "PSS22-1",
      depending: "PSS22",
      exception: "Yes",
      extend: "true",
      subtopic_container_act: "PSS22-PSS23-ACT",
      suptopic_code: "PSS22-CODE",
      subtopic_name: "Client's misrepresentation?"
    },
    {
      id: "BH.13.2",
      shortname: "pss23",
      access: "private",
      name: "",
      prevalue: "",
      value: "",
      disabled: "false",
      type: "radio",
      radio_options: [
        "No",
        "Yes"
      ],
      act: "PSS23",
      mandatory: "true",
      depending: "",
      exception: "",
      link:"PSS23-1",
      subtopic_container_act: "PSS22-PSS23-ACT",
      suptopic_code: "PSS23-CODE",
      subtopic_name: "Client’s inability to understand?"
    },
    {
      id: "BH.13.2.1",
      shortname: "pss23-1",
      name: "",
      prevalue: "If yes, please explain:",
      value: "",
      disabled: "true",
      type: "text",
      act: "PSS23-1",
      depending: "PSS23",
      exception: "Yes",
      extend: "true",
      subtopic_container_act: "PSS22-PSS23-ACT",
      suptopic_code: "PSS23-CODE",
      subtopic_name: "Client’s inability to understand?"
    },
  ]
};

export default behavioralHistoryJSON;
